module.exports = __webpack_public_path__ + "assets/img/3017.283b7341.png";